import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function MenuIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21 12C21 11.4477 20.5523 11 20 11H10C9.44771 11 9 11.4477 9 12C9 12.5523 9.44771 13 10 13H20C20.5523 13 21 12.5523 21 12Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21 5C21 4.44772 20.5523 4 20 4H4C3.44772 4 3 4.44772 3 5C3 5.55229 3.44772 6 4 6H20C20.5523 6 21 5.55228 21 5Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21 19C21 18.4477 20.5523 18 20 18H4C3.44772 18 3 18.4477 3 19C3 19.5523 3.44772 20 4 20H20C20.5523 20 21 19.5523 21 19Z"
				fill="currentColor"
			/>
		</svg>
	);
}

MenuIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default MenuIcon;
